export default function selectRandomElementFromArray<T>(arr: T[]) {
  const element = arr[Math.floor(Math.random() * arr.length)];
  return element;
}
